// src/config/areas.js
const SERVICE_AREAS = [
  {
    slug: 'maricopa',
    name: 'Maricopa',
    state: 'AZ',
    zip: '85138',
    tagline: 'The Heart of Pinal County Living',
    description: 'Maricopa offers an ideal blend of small-town charm and modern amenities. With master-planned communities, top-rated schools, and easy access to Phoenix, Maricopa has become one of Arizona\'s fastest-growing cities for families and professionals alike.',
    highlights: [
      { title: 'Master-Planned Communities', text: 'Maricopa is home to Province, Rancho El Dorado, and The Lakes at Rancho El Dorado — offering resort-style pools, parks, and walking trails.' },
      { title: 'Top Schools', text: 'Maricopa Unified School District and Leading Edge Academy provide excellent K-12 education options for families.' },
      { title: 'Commuter-Friendly', text: 'Just 35 minutes to downtown Phoenix via SR-347 and I-10, with planned freeway expansions improving access.' },
      { title: 'Outdoor Living', text: 'Enjoy year-round sunshine with Copper Sky Recreation Complex, Pacana Park, and miles of multi-use trails.' }
    ],
    marketStats: { medianPrice: '$380,000', daysOnMarket: '28 Days', popularTypes: 'Single Family, New Construction, 55+ Communities' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/maricopa-az.jpg'
  },
  {
    slug: 'ahwatukee',
    name: 'Ahwatukee',
    state: 'AZ',
    zip: '85044',
    tagline: 'Phoenix\'s Premier Foothill Community',
    description: 'Nestled between South Mountain and the Gila River Indian Community, Ahwatukee Foothills is a self-contained urban village known for its stunning mountain views, excellent schools, and upscale dining and shopping along Chandler Boulevard.',
    highlights: [
      { title: 'Mountain Views', text: 'Homes backing up to South Mountain Preserve offer unobstructed desert mountain panoramas and direct trail access.' },
      { title: 'Kyrene Schools', text: 'The Kyrene School District is consistently rated among the top districts in Arizona, making Ahwatukee a top choice for families.' },
      { title: 'Dining & Shopping', text: 'Chandler Blvd and Ray Road corridors feature upscale restaurants, boutique shopping, and Ahwatukee\'s vibrant nightlife scene.' },
      { title: 'Golf & Recreation', text: 'Multiple championship golf courses including Foothills Golf Club, plus extensive hiking and biking trails.' }
    ],
    marketStats: { medianPrice: '$525,000', daysOnMarket: '22 Days', popularTypes: 'Luxury Single Family, Hillside Homes, Townhomes' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/ahwatukee-az.jpg'
  },
  {
    slug: 'chandler',
    name: 'Chandler',
    state: 'AZ',
    zip: '85225',
    tagline: 'Innovation Meets Desert Elegance',
    description: 'Chandler is a thriving city that seamlessly blends high-tech industry with family-friendly living. Home to Intel, PayPal, and numerous tech companies, Chandler offers a strong economy, excellent schools, and a vibrant downtown entertainment district.',
    highlights: [
      { title: 'Tech Hub', text: 'Major employers like Intel, Microchip Technology, and PayPal provide high-paying jobs and economic stability.' },
      { title: 'Downtown Chandler', text: 'A walkable entertainment district with craft breweries, farm-to-table restaurants, art galleries, and weekly farmers markets.' },
      { title: 'Chandler Unified Schools', text: 'One of Arizona\'s highest-performing districts with nationally recognized STEM programs.' },
      { title: 'Tumbleweed Park', text: 'A 260-acre regional park with a recreation center, fishing lake, and the annual Ostrich Festival grounds.' }
    ],
    marketStats: { medianPrice: '$490,000', daysOnMarket: '24 Days', popularTypes: 'Single Family, Luxury Estates, Modern Townhomes' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/chandler-az.jpg'
  },
  {
    slug: 'queen-creek',
    name: 'Queen Creek',
    state: 'AZ',
    zip: '85142',
    tagline: 'Where Rural Charm Meets New Luxury',
    description: 'Queen Creek is one of the fastest-growing communities in the Phoenix metro, offering brand-new luxury homes, equestrian properties, and a tight-knit community feel. Its blend of modern amenities and open desert spaces makes it uniquely appealing.',
    highlights: [
      { title: 'New Construction', text: 'Developments like Hastings Farms, Encanterra, and Spur Cross offer modern floor plans with premium desert landscaping.' },
      { title: 'Equestrian Living', text: 'Horse properties and custom estates on acreage are abundant, perfect for those seeking space and privacy.' },
      { title: 'Queen Creek Olive Mill', text: 'A beloved local destination for farm-to-table dining, events, and Arizona\'s only working olive mill.' },
      { title: 'San Tan Mountain Regional Park', text: '10,000+ acres of Sonoran Desert hiking, mountain biking, and horseback riding trails.' }
    ],
    marketStats: { medianPrice: '$530,000', daysOnMarket: '30 Days', popularTypes: 'New Construction, Custom Estates, Horse Properties' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/queen-creek-az.jpg'
  },
  {
    slug: 'gilbert',
    name: 'Gilbert',
    state: 'AZ',
    zip: '85233',
    tagline: 'Arizona\'s Most Family-Friendly City',
    description: 'Consistently ranked among the safest and best places to live in America, Gilbert offers exceptional schools, a thriving Heritage District, and beautiful neighborhoods. Its small-town heritage blends seamlessly with modern suburban convenience.',
    highlights: [
      { title: 'Heritage District', text: 'Gilbert\'s charming downtown features locally-owned restaurants, craft breweries, boutique shops, and a vibrant weekend scene.' },
      { title: 'Gilbert Public Schools', text: 'Among the top-performing districts in Arizona with award-winning programs in academics, arts, and athletics.' },
      { title: 'Riparian Preserve', text: 'A 110-acre urban wildlife refuge with fishing, birdwatching, astronomy observatory, and miles of walking paths.' },
      { title: 'Safety & Community', text: 'Ranked one of the safest cities in the US with active neighborhood associations and community events year-round.' }
    ],
    marketStats: { medianPrice: '$545,000', daysOnMarket: '20 Days', popularTypes: 'Single Family, Luxury Homes, New Construction' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/gilbert-az.jpg'
  },
  {
    slug: 'tempe',
    name: 'Tempe',
    state: 'AZ',
    zip: '85281',
    tagline: 'Urban Energy, Desert Soul',
    description: 'Home to Arizona State University and Tempe Town Lake, Tempe is a dynamic city that attracts young professionals, investors, and families alike. Its walkable downtown, light rail access, and diverse housing make it a premier East Valley destination.',
    highlights: [
      { title: 'Tempe Town Lake', text: 'A 220-acre urban lake surrounded by parks, trails, restaurants, and the iconic Tempe Center for the Arts.' },
      { title: 'ASU & Innovation', text: 'Arizona State University drives a thriving economy with research parks, startups, and a highly educated workforce.' },
      { title: 'Mill Avenue District', text: 'Tempe\'s iconic entertainment corridor with rooftop bars, live music, shopping, and dining steps from the lake.' },
      { title: 'Light Rail Access', text: 'Valley Metro light rail connects Tempe to Phoenix, Mesa, and the airport — ideal for commuters.' }
    ],
    marketStats: { medianPrice: '$460,000', daysOnMarket: '18 Days', popularTypes: 'Condos, Townhomes, Investment Properties, Single Family' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/tempe-az.jpg'
  },
  {
    slug: 'mesa',
    name: 'Mesa',
    state: 'AZ',
    zip: '85201',
    tagline: 'Arizona\'s Adventure Capital',
    description: 'As Arizona\'s third-largest city, Mesa offers incredible diversity in housing, recreation, and culture. From the arts district downtown to the outdoor adventures of Usery Mountain, Mesa provides something for everyone at accessible price points.',
    highlights: [
      { title: 'Mesa Arts Center', text: 'The largest arts center in Arizona featuring world-class performances, galleries, and educational programs.' },
      { title: 'Usery Mountain Regional Park', text: 'Desert hiking and mountain biking trails with stunning views of the Superstition Mountains and Salt River Valley.' },
      { title: 'Spring Training', text: 'Home to Chicago Cubs spring training at Sloan Park, plus numerous professional sports and recreation facilities.' },
      { title: 'Affordable Luxury', text: 'Southeast Mesa offers newer communities with larger lots and mountain views at prices below Chandler and Gilbert.' }
    ],
    marketStats: { medianPrice: '$420,000', daysOnMarket: '25 Days', popularTypes: 'Single Family, New Construction, 55+ Communities' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/mesa-az.jpg'
  },
  {
    slug: 'casa-grande',
    name: 'Casa Grande',
    state: 'AZ',
    zip: '85122',
    tagline: 'Space, Value, and Desert Beauty',
    description: 'Situated between Phoenix and Tucson along I-10, Casa Grande offers exceptional value with spacious homes, large lots, and a growing economy. Its strategic location and affordability make it increasingly popular with remote workers and growing families.',
    highlights: [
      { title: 'Exceptional Value', text: 'Larger homes and lots at significantly lower prices than Phoenix metro, with many new construction options available.' },
      { title: 'Casa Grande Ruins', text: 'A National Monument preserving 2,000-year-old Hohokam structures — a unique cultural landmark in your backyard.' },
      { title: 'Growing Economy', text: 'Major distribution centers, manufacturing, and the planned Lucid Motors factory are driving job growth.' },
      { title: 'I-10 Corridor', text: 'Easy access to both Phoenix (45 min) and Tucson (45 min) makes Casa Grande ideal for dual-city commuters.' }
    ],
    marketStats: { medianPrice: '$310,000', daysOnMarket: '32 Days', popularTypes: 'Single Family, New Construction, Land & Custom Builds' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/casa-grande-az.jpg'
  },
  {
    slug: 'goodyear',
    name: 'Goodyear',
    state: 'AZ',
    zip: '85338',
    tagline: 'West Valley\'s Rising Star',
    description: 'Goodyear has transformed from a quiet farming community into one of the most desirable cities in the Phoenix metro. With master-planned communities, excellent schools, and proximity to major employers, Goodyear offers modern suburban living at its best.',
    highlights: [
      { title: 'Estrella Mountain Ranch', text: 'A premier master-planned community with championship golf, a waterpark, hiking trails, and resort-style amenities.' },
      { title: 'Palm Valley', text: 'Established luxury community with mature landscaping, top schools, and easy freeway access.' },
      { title: 'Goodyear Ballpark', text: 'Spring training home of the Cleveland Guardians and Cincinnati Reds with year-round entertainment.' },
      { title: 'I-10 & Loop 303', text: 'Major freeway access provides quick commutes to downtown Phoenix and the West Valley employment corridor.' }
    ],
    marketStats: { medianPrice: '$450,000', daysOnMarket: '26 Days', popularTypes: 'Single Family, Master-Planned, New Construction' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/goodyear-az.jpg'
  },
  {
    slug: 'buckeye',
    name: 'Buckeye',
    state: 'AZ',
    zip: '85326',
    tagline: 'Arizona\'s Fastest-Growing Frontier',
    description: 'Buckeye is the fastest-growing city in Arizona and one of the fastest in the nation. Offering brand-new communities, affordable pricing, and vast open spaces, Buckeye represents the frontier of Phoenix metro expansion.',
    highlights: [
      { title: 'Verrado', text: 'A nationally recognized master-planned community with a walkable Main Street, mountain trails, and award-winning schools.' },
      { title: 'New Home Capital', text: 'Dozens of builders offering the latest floor plans and smart home technology at competitive price points.' },
      { title: 'Skyline Regional Park', text: 'Scenic hiking trails with panoramic views of the White Tank Mountains and surrounding desert.' },
      { title: 'Future Growth', text: 'Planned infrastructure including freeways, shopping, and commercial centers will dramatically increase property values.' }
    ],
    marketStats: { medianPrice: '$390,000', daysOnMarket: '30 Days', popularTypes: 'New Construction, Single Family, Master-Planned Communities' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/buckeye-az.jpg'
  },
  {
    slug: 'san-tan-valley',
    name: 'San Tan Valley',
    state: 'AZ',
    zip: '85140',
    tagline: 'Family Living with Mountain Views',
    description: 'San Tan Valley offers affordable family homes surrounded by dramatic desert mountain scenery. With growing schools, expanding retail, and a strong sense of community, it\'s become a top choice for families seeking value without sacrificing lifestyle.',
    highlights: [
      { title: 'San Tan Mountain Regional Park', text: 'Over 10,000 acres of hiking, horseback riding, and mountain biking trails with stunning Sonoran Desert scenery.' },
      { title: 'Family Communities', text: 'Johnson Ranch, Circle Cross Ranch, and Pecan Creek offer family-oriented amenities, pools, and community events.' },
      { title: 'Growing Schools', text: 'J.O. Combs Unified School District is expanding with new campuses and award-winning academic programs.' },
      { title: 'Value & Space', text: 'Larger lots and newer homes at prices well below Gilbert and Queen Creek, with similar quality of life.' }
    ],
    marketStats: { medianPrice: '$380,000', daysOnMarket: '28 Days', popularTypes: 'Single Family, New Construction, Horse Properties' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/san-tan-valley-az.jpg'
  },
  {
    slug: 'coolidge',
    name: 'Coolidge',
    state: 'AZ',
    zip: '85128',
    tagline: 'Rural Luxury & Arizona Heritage',
    description: 'Coolidge offers a unique blend of small-town Arizona heritage and rural luxury living. With large lots, custom home opportunities, and a historic downtown, Coolidge appeals to those seeking space, privacy, and authentic desert living.',
    highlights: [
      { title: 'Large Lots & Custom Homes', text: 'Acre+ properties perfect for custom builds, horse properties, and those wanting space and privacy.' },
      { title: 'Historic Downtown', text: 'A charming Main Street with local shops, the historic Coolidge Theater, and community events.' },
      { title: 'Casa Grande Ruins Proximity', text: 'Minutes from the National Monument, plus close to Florence and the scenic Gila River corridor.' },
      { title: 'Agricultural Heritage', text: 'Cotton fields, pecan groves, and working ranches create a uniquely Arizona landscape.' }
    ],
    marketStats: { medianPrice: '$285,000', daysOnMarket: '35 Days', popularTypes: 'Custom Homes, Horse Properties, Land, Agricultural' },
    image: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/areas/coolidge-az.jpg'
  }
];

module.exports = { SERVICE_AREAS };
